import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { Redirect, withRouter } from "react-router";
import { LoginLayout } from "./login/LoginLayout";
const Login = props => {
  console.log(props.Login);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [wrongPassFlag, setwrongPassFlag] = useState(false);
  const [captchaError, setCaptchaError] = useState(false);
  const [logging, setLogging] = useState(false);
  const recaptchaRef = useRef(null);
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);

  useEffect(() => {
    // Load reCAPTCHA script
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => setRecaptchaLoaded(true);
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const Test = event => 
  {
    let urls =  [
    'https://cairoreg.aast.edu/aastreg/','https://alexreg.aast.edu/aastreg/','https://cairoreg2.aast.edu/aastreg/','https://alexreg2.aast.edu/aastreg/'
  ,'https://othersreg.aast.edu/aastreg/','https://cairoreg3.aast.edu/aastreg/','https://alexreg3.aast.edu/aastreg/']
  //  let urls= ['https://aastmtic.aast.edu/registrationapi/redirect.html?x=1']
    window.open( urls[Math.floor(Math.random() * urls.length)],'_blank');

   
  }
  const OnLoginCLick = event => {
    event.preventDefault();
    
    // Get captcha token
    let captchaToken = '';
    if (window.grecaptcha && recaptchaLoaded) {
      captchaToken = window.grecaptcha.getResponse();
      if (!captchaToken) {
        setCaptchaError(true);
        setwrongPassFlag(false);
        return;
      }
    }
    
    setCaptchaError(false);
    setwrongPassFlag(false);
    setLogging(true);
    
    Axios.post(
      "api/login/login",
      {
        userName,
        password,
        captchaToken
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then(function(response) {
        console.log(response);

        if (response.data == "-1") {
          setwrongPassFlag(true);
          setLogging(false);
          // Reset captcha
          if (window.grecaptcha && recaptchaLoaded) {
            window.grecaptcha.reset();
          }
        }
        else if (response.data == "-2") {
          window.open("https://paperless.aast.edu/worklist/systemupdates.htm",  "_self");
          setLogging(false);
        }
        else if (response.data == "-3") {
          setCaptchaError(true);
          setLogging(false);
          // Reset captcha
          if (window.grecaptcha && recaptchaLoaded) {
            window.grecaptcha.reset();
          }
        }
        else {
          props.Login(response.data);
        }
      })
      .catch(function(error) {
        console.log(error);
        setLogging(false);
        // Reset captcha
        if (window.grecaptcha && recaptchaLoaded) {
          window.grecaptcha.reset();
        }
      });
  };
  const OnForgetPassword = event => {
    //alert(userName + " " + password)
     console.log(event)
    event.preventDefault();

    setLogging(true);
    Axios.post(
      "api/login/ForgetPassword",
      {
        userName
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    ).then(function(response) {
      console.log(response);
      setLogging(false);

      if (response.data == "-1") {
          alert('error sending email')

      }
      else
      {
        alert('email sent successfully')
      }
    }).catch(function(error) {
      alert('error sending email')
    });;
  };
  //window.showAnnoncementModal();
 
  return (
    <div>
      {!props.isLogin && (
        <LoginLayout Forget={OnForgetPassword}>
          {wrongPassFlag ? (
            <div className="alert alert-danger fade show m-b-10">
              <span className="close" data-dismiss="alert">
                ×
              </span>
              Registration Number and Pin Code dose not matched. Please type
              them correctly. if you forget your Pin Code
              <button
                onClick={OnForgetPassword}
                className="alert-link"
               >
              
                Click Here
              </button>
              .
            </div>
          ) : (
            <div></div>
          )}
          {captchaError ? (
            <div className="alert alert-warning fade show m-b-10">
              <span className="close" data-dismiss="alert" onClick={() => setCaptchaError(false)}>
                ×
              </span>
              Please verify that you are not a robot by completing the CAPTCHA.
            </div>
          ) : (
            <div></div>
          )}
          <form className="margin-bottom-0">


          {/*<div className="alert alert-warning fade show m-b-10" style={{fontSize: 14, fontWeight: 600, direction: 'rtl',}}>*/}
          {/*    <span className="close" data-dismiss="alert">*/}
          {/*      ×*/}
          {/*    </span>*/}
          {/*    لأفضل تجربة إستخدام يرجى إستخدام المتصفح FireFox*/}
          {/*  </div>*/}
            <hr/>
            <h5>Registration</h5>
                <div className="row">
                  <div className="col-md-12 col-xs-12">
                
                <button
                  className="btn btn-danger btn-block btn-lg"
                  onClick={Test}
                  type='button'
                >
                  Open Registration
                </button>
 
                  </div>
                </div>
                <hr/>
                <h5>Login</h5>
            <div className="form-group m-b-15">
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="Registration Number"
                name="username"
                value={userName}
                onChange={event => setUserName(event.target.value)}
                required
              />
            </div>
            <div className="form-group m-b-15">
              <input
                type="password"
                className="form-control form-control-lg"
                placeholder="Pin Code"
                name="password"
                value={password}
                onChange={event => setPassword(event.target.value)}
                required
              />
                      </div>
                      <div className="form-group m-b-15 justify-center ">
                          <div className="g-recaptcha" data-sitekey="6Lfn_tcSAAAAAAihecoOc56MlYZMi2szVcT_K3VG" ref={recaptchaRef}></div>
                      </div>
            <div className="checkbox checkbox-css m-b-30">
              <input type="checkbox" id="remember_me_checkbox" value="" />
              <label htmlFor="remember_me_checkbox">Remember Me</label>
            </div>
           
            <div className="login-buttons">
              {!logging ? (
                <div>
                
                
                <button
                  type="submit"
                  className="btn btn-primary btn-block btn-lg"
                  onClick={OnLoginCLick}
                >
                  Login
                </button>

             
                
                
                
                  
                
                  
       </div>
              ) : (
                <button
                  type="submit"
                  className="btn btn-default btn-block btn-lg"
                  disabled="disabled"
                >
                  <i className="fas fa-spinner fa-spin"></i>
                </button>
              )}
            </div>
          </form>
          <div class="modal fade" id="announcement-modal">
								<div class="modal-dialog  modal-lg ">
									<div class="modal-content">
										<div class="modal-header">
											<h4 class="modal-title">Student Announcements</h4>
											<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
										</div>
										<div class="modal-body">



                      <div id="carouselExampleInterval" className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner">
                        <div className="carousel-item active"  data-interval="5000">
                            <a href={`assets/img/widgets/qnb1.png`} target="_blank" rel="noopener noreferrer">
                              <img src={`assets/img/widgets/qnb1.png`} className="d-block w-100 rounded" alt="" />
                            </a>
                          </div>
                          <div className="carousel-item  "  data-interval="5000">
                            <a href={`assets/img/widgets/qnb2.png`} target="_blank" rel="noopener noreferrer">
                              <img src={`assets/img/widgets/qnb2.png`} className="d-block w-100 rounded" alt="" />
                            </a>
                          </div>
                          <div className="carousel-item " data-interval="5000">
                            <a href={`assets/img/widgets/corona.png`} target="_blank" rel="noopener noreferrer">
                              <img src={`assets/img/widgets/corona.png`} className="d-block w-100 rounded" alt="" />
                            </a>
                          </div>
                      
                        </div>
                        <a className="carousel-control-prev" href="#carouselExampleInterval" role="button" data-slide="prev">
                          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span className="sr-only">Previous</span>
                        </a>
                        <a className="carousel-control-next" href="#carouselExampleInterval" role="button" data-slide="next">
                          <span className="carousel-control-next-icon" aria-hidden="true"></span>
                          <span className="sr-only">Next</span>
                        </a>
                      </div>



										</div>
										
									</div>
								</div>
							</div>
        </LoginLayout>
        
      )}

      </div>
    
  );
};

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js